import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RuntimeEnv } from 'src/app/services/runtime-env.service';

@Component({
  selector: 'app-environment-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './environment-badge.component.html',
  styleUrls: ['./environment-badge.component.css'],
})
export class EnvironmentBadgeComponent {
  @Input() env: RuntimeEnv = 'QA';
}
